import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

export default function GrandForksPage() {
  return (
    <>
      <CitySEOHead
        city="Grand Forks"
        state="North Dakota"
        stateAbbr="ND"
        route="/cities/grand-forks"
        title="Emergency Passport Grand Forks, ND — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Grand Forks, North Dakota. Serving Grand Forks County, UND community, East Grand Forks MN, and surrounding areas. As fast as 24 hours — no Minneapolis agency trip needed."
        geoPlacename="Grand Forks, North Dakota"
        geoPosition="47.9253;-97.0329"
        faqs={[]}
        servicesSchema={[]}
        statePageName="North Dakota"
        statePageRoute="/states/north-dakota"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <LocalAreaSection />
        <ServicesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}